/* eslint-disable max-len */
import React, { Component } from 'react';
import Address from './Address';
import FormError from '../../components/Alert/FormError';
import Loading from '@justgiving/loading';
import PageHeader from '../../components/PageHeader/PageHeader';
import { PropTypes } from 'prop-types';
import { Trans } from 'react-i18next';
import { getCountryNameByIsoCode } from 'i18n/country-map';
import PhoneNumber from './PhoneNumber';

const propTypes = {
  fetchData: PropTypes.func.isRequired,
  trackPageView: PropTypes.func.isRequired,
  status: PropTypes.shape({
    isFetching: PropTypes.bool,
    fetchError: PropTypes.bool,
  }).isRequired,
  user: PropTypes.shape({
    PhoneNumber: PropTypes.string,
  }),
  userAddress: PropTypes.shape({
    AddressLine1: PropTypes.string,
    AddressLine2: PropTypes.string,
    Town: PropTypes.string,
    County: PropTypes.string,
    Country: PropTypes.string,
    PostCode: PropTypes.string,
    CountryCode: PropTypes.string,
    State: PropTypes.string,
    UserAddressId: PropTypes.number,
  }),
  localeData: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
  user: PropTypes.shape({
    PhoneNumber: undefined,
  }),
  userAddress: PropTypes.shape({
    AddressLine1: undefined,
    AddressLine2: undefined,
    Town: undefined,
    County: undefined,
    Country: undefined,
    PostCode: undefined,
  }),
};

class ContactDetailsComponent extends Component {
  componentDidMount() {
    const { trackPageView, fetchData } = this.props;
    fetchData();
    trackPageView('contact details', 'contact details');
  }

  getPageComponents() {
    const { user, userAddress } = this.props;
    const countryCode = userAddress.CountryCode;
    const country = getCountryNameByIsoCode(countryCode);
    const hasValue = value => Boolean(value);
    const hasPhoneNumber = hasValue(user.PhoneNumber);

    return (
      <>
        <Address
          addressLine1={userAddress.AddressLine1}
          addressLine2={userAddress.AddressLine2}
          town={userAddress.Town}
          county={userAddress.County}
          country={country}
          state={userAddress.State}
          postCode={userAddress.PostCode}
          userAddressId={userAddress.UserAddressId}
        />
        {hasPhoneNumber && <PhoneNumber phoneNumber={user.PhoneNumber} />}
      </>
    );
  }

  render() {
    const { status } = this.props;

    if (status.isFetching) {
      return (
        <div className="jg-space-mtxl">
          <Loading size="large" />
        </div>
      );
    }

    const PageComponents = this.getPageComponents();

    let content = PageComponents;
    if (status.fetchError) {
      content = (
        <div className="jg-space-mhlg@lg">
          <FormError error />
        </div>
      );
    }

    return (
      <div className="jg-background--white jg-bd@lg jg-bd--very-light-grey">
        <div className="jg-space-psm jg-space-plg@lg">
          <PageHeader>
            <h1 className="qa-page__heading">
              <Trans i18nKey="contactDetails.title">Contact details</Trans>
            </h1>
            <p className="jg-text--medium-light">
              <Trans i18nKey="contactDetails.text">
                You can update your address and phone number here.
              </Trans>
            </p>
          </PageHeader>
        </div>
        {content}
      </div>
    );
  }
}

ContactDetailsComponent.propTypes = propTypes;

ContactDetailsComponent.defaultProps = defaultProps;

export default ContactDetailsComponent;
